<template>
  <div class="schedule-chart relative">
    <div
      :class="[openStatus ? 'schedule-chart-open' : 'schedule-chart-collapse']"
      class="transition-all ease-in-out overflow-hidden duration-300"
    >
      <div class="flex flex-row justify-between pt-16">
        <ButtonGroup>
          <Button
            v-for="(item, index) in SCHEDULE_TABS"
            :key="index"
            :type="activeIndex == index ? 'primary' : 'secondary'"
            @click="changeActiveIndex(index)"
          >
            {{ $t(item.name) }}
          </Button>
        </ButtonGroup>
        <div
          class="flex flex-row items-center"
          v-if="isMyself"
        >
          <span class="text-text-3">{{ $t('C1038') }}</span>
          <ul class="flex flex-row justify-start items-center text-14 mr-16">
            <li
              v-for="(item, index) in todayData"
              :key="index"
              class="px-10"
            >
              <Badge
                status="normal"
                :color="ATTR_COLOR[item.key]"
              />
              <span
                :style="{
                  color: ATTR_COLOR[item.key]
                }"
                class="ml-5"
              >
                {{ $t(item.name) }} {{ item.count }}
              </span>
            </li>
          </ul>
          <div>
            <Popover
              position="lt"
              content-class="schedule-popover"
              trigger="click"
            >
              <span class="iconfont cursor-pointer iconicon_jichutubiao_shaixuan1 hover:text-primary-6" />
              <template #content>
                <div class="schedule-popover-content">
                  <CheckboxGroup
                    v-model="attrChecked.attrList"
                    direction="vertical"
                    @change="handleCheckGroupChange"
                  >
                    <Checkbox
                      v-for="(item, index) in checkList"
                      :key="index"
                      :value="item.key"
                    >
                      {{ $t(item.name) }}
                    </Checkbox>
                  </CheckboxGroup>
                  <Divider
                    v-if="checkList.length"
                    :margin="5"
                  />
                  <CheckboxGroup
                    v-model="attrChecked.decorateList"
                    direction="vertical"
                    @change="handleCheckGroupChange"
                  >
                    <Checkbox
                      v-for="(item, index) in DECORATE_LIST"
                      :key="index"
                      :value="item.key"
                    >
                      {{ $t(item.name) }}
                    </Checkbox>
                  </CheckboxGroup>
                </div>
              </template>
            </Popover>
          </div>
          <!-- <span class="iconfont iconicon_jichutubiao_shaixuan1 text-20 text-text-3 cursor-pointer" /> -->
        </div>
      </div>
      <svg class="svg-score-gradient">
        <!-- 水平渐变 -->
        <defs>
          <linearGradient
            id="6WeekAvgTL"
            x1="100%"
            y1="100%"
            x2="0%"
            y2="0%"
          >
            <!-- 设置渐变色，使用stop标签 -->
            <stop
              offset="0%"
              stop-color="rgba(170,219,55,0.1)"
              stop-opacity=""
            />
            <stop
              offset="100%"
              stop-color="rgba(170,219,55,0.5)"
              stop-opacity=""
            />
          </linearGradient>
          <linearGradient
            id="7DayAvgTL"
            x1="100%"
            y1="100%"
            x2="0%"
            y2="0%"
          >
            <!-- 设置渐变色，使用stop标签 -->
            <stop
              offset="0%"
              stop-color="rgba(49,112,255,0.1)"
              stop-opacity=""
            />
            <stop
              offset="100%"
              stop-color="rgba(49,112,255,0.5)"
              stop-opacity=""
            />
          </linearGradient>
          <linearGradient
            id="tiredRateNew"
            x1="100%"
            y1="100%"
            x2="0%"
            y2="0%"
          >
            <!-- 设置渐变色，使用stop标签 -->
            <stop
              offset="0%"
              stop-color="rgba(255,158,15,0.1)"
              stop-opacity=""
            />
            <stop
              offset="100%"
              stop-color="rgba(255,158,15,0.5)"
              stop-opacity=""
            />
          </linearGradient>
        </defs>
      </svg>

      <div
        ref="sumChart"
        class="chart-container px-10"
      />
    </div>
    <!-- 折叠按钮 -->
    <div
      class="schedule-close-btn absolute cursor-pointer transition-all duration-150 ease-in-out"
      :class="[openStatus ? 'schedule-close-btn-open' : 'schedule-close-btn-close']"
      @click="changeOpenStatus"
    >
      <span
        class="iconfont select-icon text-16"
        :class="[openStatus ? 'iconicon_jichutubiao_jiantou_shouqi icon-up' : 'iconicon_jichutubiao_jiantou_xiala icon-down']"
      />
    </div>
  </div>
</template>
<script>
import { SCHEDULE_TABS, TABS_DATA, DECORATE_LIST, TRAININGLOAD_TAB } from '@client/pages/personal/config/instance';

import { userStore } from '@client/store/userStore';

import { mapActions, mapState } from 'pinia';
import { MONTH_TRANSLATE } from '@client/pages/personal/schedule/calender/instance';
import { ButtonGroup, Button, Badge, Popover, CheckboxGroup, Checkbox, Divider } from '@arco-design/web-vue';

import dayjs from 'dayjs';
import { cloneDeep } from 'lodash';
import { getScheduleAssetsFile } from '@client/helper/asset';
import { ATTR_COLOR, LABEL_TYPE, ATTR_PATH_COLOR } from '@client/pages/personal/schedule/scheduleChart/config';
import { OverviewChart } from '@client/pages/personal/schedule/scheduleChart/chart';
import { getLastMonday, getMonthStartAndEnd } from '@client/helper/day';
import PlanInstance from './instance.js';
export default {
  name: 'SchedulePlanCommon',
  mixins: [PlanInstance],
  components: { ButtonGroup, Button, Badge, Popover, CheckboxGroup, Checkbox, Divider },
  props: {
    teamId: {
      type: String,
      default: ''
    },
    userId: {
      type: String,
      default: ''
    },
    isMyself: {
      type: Boolean,
      default: false
    }
  },
  data: function () {
    return {
      SCHEDULE_TABS,
      activeIndex: 0,
      openStatus: true,
      startDate: '20220509',
      endDate: '20230507',
      nowWeekNum: 24,
      weekCount: 52,
      checkList: [],
      DECORATE_LIST: cloneDeep(DECORATE_LIST),
      // 勾选了的
      attrChecked: {
        attrList: [], //'6WeekAvgTL', '7DayAvgTL', 'fatigueLoad', 'trainingLoad'
        decorateList: [] //'cyclePhase', 'label'
      },
      tabsData: cloneDeep(TABS_DATA),
      xAxisKey: 'timestamp',

      scheduleData: {
        dayTrainSums: {},
        weekTrains: {}
      },

      dayData: [],
      weekData: [],
      monthData: [],
      weekStageColorLine: [],
      showingAttrs: [],
      modelValidState: true,
      ATTR_COLOR
    };
  },

  computed: {
    ...mapState(userStore, ['unit']),
    activeTab() {
      return SCHEDULE_TABS[this.activeIndex].key;
    }
  },
  created() {
    this.initConfig();
    let { name } = this.$route;
    this.name = name;
    if (name === 'schedule' || name === 'team') {
      this.initDate();
      this.getScheduleSumData();
    }
  },
  mounted() {
    // 防止渲染时已存在数据
    if (this.chartData.data.length) {
      this.handleData(this.chartData);
    }
  },
  methods: {
    initConfig() {
      this.attrChecked.attrList = [];
      this.checkList = cloneDeep(TABS_DATA);
      this.checkList.push(TRAININGLOAD_TAB);
      this.checkList.forEach((item) => {
        if (item.default) this.attrChecked.attrList.push(item.key);
      });
      this.DECORATE_LIST.forEach((item) => {
        this.attrChecked.decorateList.push(item.key);
      });
    },
    changeActiveIndex(index) {
      this.activeIndex = index;
      if (this.name === 'schedule') {
        this.changeScheduleActiveIndex(index);
      } else {
        // 训练计划切换
        this.changePlanActiveIndex();
      }
    },
    changeOpenStatus() {
      this.openStatus = !this.openStatus;
    },
    dealEventData(weekEventTags = []) {
      const result = [];
      const obj = {};
      weekEventTags.forEach((item) => {
        let { happenDay, type } = item;
        if (!obj[happenDay]) {
          obj[happenDay] = {
            happenDay,
            data: []
          };
        }

        item.image = LABEL_TYPE[type].icon;
        item.typeName = this.$t(LABEL_TYPE[type].text);
        obj[item.happenDay].data.push(item);
      });

      for (const n in obj) {
        result.push(obj[n]);
      }

      result.sort((a, b) => {
        return a.happenDay - b.happenDay;
      });
      return result;
    },
    // 设置显示的属性
    setAttributes() {
      const chart = this.chart;
      chart.setShowingAttributes(this.showingAttrs);
    },
    drawChart() {
      const { xAxisKey, weekCount, dayData = [] } = this;
      if (this.chart && this.chart.remove) {
        this.chart.remove();
      }

      const el = this.$refs.sumChart;
      if (!el) {
        return;
      }
      this.chart = new OverviewChart({
        el,
        theme: 'dark',
        margin: {
          top: 50,
          bottom: 37,
          left: 0,
          right: 0
        },
        linearGradients: ATTR_PATH_COLOR,
        // x轴刻度线长度
        xTickLineSize: 10,
        // x轴使用的属性字段名
        xAxisKey,
        // x轴刻度显示的文本信息转换方法，不传则直接使用属性值
        // xTickInfo: this.xTickInfo,
        weekCount
      });
      // 注入数据
      this.chart.setData(dayData);
      // 创建x轴比例尺
      this.chart.createXAxis([dayData[0][xAxisKey], dayData[dayData.length - 1][xAxisKey]]);
      this.setDecorate();
      // 绘制背景
      this.chart.setBg(this.monthData);
      // 绘制x轴
      this.chart.drawXScale(this.weekData, this.weekStageColorLine);
      // 设置显示的图表
      this.setAttributes();
    },
    // 背景月份数据
    handleMonthData() {
      const result = [];
      const dayData = cloneDeep(this.dayData);
      if (dayData.length === 0) {
        return result;
      }
      const yearStartTimestamp = dayData[0].timestamp;
      const yearEndTimestamp = dayData[dayData.length - 1].timestamp;

      const colorMap = {
        0: 'rgba(255,255,255,0.01)',
        1: 'rgba(255,255,255,0.03)'
      };
      const date_format = 'YYYYMMDD';
      const oneDaySecond = 3600 * 24 * 1000;

      let startTimestamp = yearStartTimestamp;
      for (let n = 0; n < 15; n++) {
        const monthStartAndEnd = getMonthStartAndEnd(startTimestamp, date_format);

        const [monthStart, monthEnd] = monthStartAndEnd;
        if (monthStart.valueOf() > yearEndTimestamp && monthEnd.valueOf() > yearEndTimestamp) {
          break;
        }
        const _month = monthStart.format('MM');
        const monthInfo = {
          color: colorMap[n % 2],
          startTimestamp: monthStart.valueOf(),
          endTimestamp: monthEnd.valueOf() + oneDaySecond,
          text: this.$t(MONTH_TRANSLATE[_month].label),
          yearText: ''
          // yearText: dayjs(monthStartAndEnd[0].getTime()).format('YYYY')
        };

        if (!monthStart.month()) {
          monthInfo.text = monthStart.year();
        }

        result.push(monthInfo);
        startTimestamp = monthEnd.valueOf() + oneDaySecond;
      }

      if (result[0].startTimestamp < yearStartTimestamp) {
        result[0].startTimestamp = yearStartTimestamp;
      }

      if (result[result.length - 1].endTimestamp > yearEndTimestamp) {
        result[result.length - 1].endTimestamp = yearEndTimestamp;
      }
      this.monthData = result;
    },
    // 图表周数据
    handleWeekData() {
      const result = [];
      let { weekCount, nowWeekNum, scheduleData } = this;

      const { weekTrains = {} } = scheduleData;
      const date_format = 'YYYYMMDD';
      const today = dayjs().format(date_format);

      for (let w = 0; w < weekCount; w++) {
        const weekBeginDay = getLastMonday(today, date_format, w + 1 - nowWeekNum);
        const weekBeginDateObj = dayjs(weekBeginDay, date_format);
        const weekEndDateObj = dayjs(weekBeginDateObj).add(6, 'day');
        const firstDayInWeek = weekBeginDay;
        const weekTrain = weekTrains[firstDayInWeek] || {};
        // 周阶段信息
        let { weekStage = {}, weekEventTags, weekTrainSum = {} } = weekTrain;

        // 每周的事件标签数据
        weekEventTags = this.dealEventData(weekEventTags);

        const weekInfo = {
          // 第几周
          weekNum: w + 1,
          // 用于定位x轴坐标的位置，与周一一致
          timestamp: weekBeginDateObj.valueOf(),
          // 所在周的周一时间戳
          weekBeginTimestamp: weekBeginDateObj.valueOf(),
          // 所在周的周日时间戳
          weekEndTimestamp: weekEndDateObj.valueOf(),

          // 刻度文本
          text: '',

          // 周阶段枚举，1：准备期，2：基础期，3：培养期，4：巅峰期，5：竞赛期，6：过渡期
          weekStage: weekStage.stage || 0,
          // weekStage: Math.round(Math.random() * 6),

          // 训练负荷
          trainingLoad: {
            // 计划值
            planValue: Number(weekTrainSum.planTrainingLoad) || 0,
            // 实际值
            actualValue: Number(weekTrainSum.actualTrainingLoad) || 0,
            color: ATTR_COLOR.trainingLoad
          },

          // 运动时间
          duration: {
            // 计划值
            planValue: Number(weekTrainSum.planDuration) || 0,
            // 实际值
            actualValue: Number(weekTrainSum.actualDuration) || 0,
            color: ATTR_COLOR.duration
          },

          // 运动距离
          distance: {
            // 计划值
            planValue: Number(weekTrainSum.planDistance) || 0,
            // 实际值
            actualValue: Number(weekTrainSum.actualDistance) || 0,
            color: ATTR_COLOR.distance
          },

          weekEventTags,
          weekEventImage: getScheduleAssetsFile('label.svg')
        };
        // 设置刻度文本
        if ([nowWeekNum - 1, nowWeekNum, nowWeekNum + 1].includes(w + 1)) {
          weekInfo.text = {
            [nowWeekNum - 1]: '',
            [nowWeekNum]: this.$t('R2001'),
            [nowWeekNum + 1]: ''
          }[w + 1];
        }

        result.push(weekInfo);
      }
      this.weekData = result;
    },
    handleDayData() {
      const result = [];
      let { nowWeekNum, weekCount, scheduleData = {} } = this;
      const date_format = 'YYYYMMDD';
      const today = dayjs().format(date_format);

      const timeDay = getLastMonday(today, date_format, -(nowWeekNum - 1)); // getLastMonday(-(nowWeekNum - 1));

      const timeDate = dayjs(timeDay, date_format);
      const { dayTrainSums = {} } = scheduleData;
      const display_format = this.$t('C6003');
      for (let w = 0; w < weekCount; w++) {
        const weekBegin = w * 7;
        const weekBeginDay = getLastMonday(today, date_format, w + 1 - nowWeekNum);
        const weekBeginDateObj = dayjs(weekBeginDay, date_format);
        const weekEndDateObj = dayjs(weekBeginDateObj).add(6, 'day');
        for (let d = 0; d < 7; d++) {
          // 第几天
          const dateNum = weekBegin + d + 1;
          const date = timeDate.add(w * 7 + d, 'day');
          const dayTrainSum = dayTrainSums[date.format('YYYYMMDD')] || {};
          const { planCti, actualCti, planAti, actualAti, planTiredRateNew, actualTiredRateNew } = dayTrainSum;

          result.push({
            // 第几天
            dateNum,
            dateNumText: date.format(display_format),
            // 星期几
            dayNum: d + 1,
            // 第几周
            weekNum: w + 1,
            weekNumText: `${weekBeginDateObj.format(display_format)} - ${weekEndDateObj.format(display_format)}`,
            // 所在周的周一时间戳
            weekBeginTimestamp: weekBeginDateObj.valueOf(),
            // 所在周的周日时间戳
            weekEndTimestamp: weekEndDateObj.valueOf(),

            // 第几天的时间戳
            timestamp: date.valueOf(),

            // 长期负荷
            '6WeekAvgTL': {
              // 计划值
              planValue: planCti,
              // 实际值
              actualValue: actualCti,
              color: ATTR_COLOR['6WeekAvgTL']
            },

            // 短期负荷
            '7DayAvgTL': {
              // 计划值
              planValue: planAti,
              // 实际值
              actualValue: actualAti,
              color: ATTR_COLOR['7DayAvgTL']
            },

            // 负荷比
            tiredRateNew: {
              // 计划值
              planValue: planTiredRateNew,
              // 实际值
              actualValue: actualTiredRateNew,
              color: ATTR_COLOR['tiredRateNew']
            },

            dayTrainSum
          });
        }
      }
      this.dayData = result;
      this.mixTabsData();
    },
    mixTabsData() {
      const { scheduleData = {}, tabsData } = this;
      const today = dayjs().format('YYYYMMDD');
      const { dayTrainSums = {} } = scheduleData;
      const todayTrainingSum = dayTrainSums[today];
      if (todayTrainingSum.actualCti === undefined) {
        this.tabsData = [];
        this.checkList = [TRAININGLOAD_TAB];
        return;
      }
      tabsData.forEach((item) => {
        const value = todayTrainingSum[item.valueKey] || 0;
        item.count = value;
      });
    }
  }
};
</script>
<style lang="scss">
@import '@client/styles/_mixins.scss';

.chart-container {
  height: px2rem144(190);
  background-color: #0f142c;
}
.schedule-close-btn {
  content: ' ';
  position: absolute;
  top: 100%;
  left: 50%;
  transform: translate(-50%);
  width: px2rem144(80);
  border-color: rgba(255, 255, 255, 0.2) transparent transparent;
  border-style: solid;
  border-width: px2rem144(12) px2rem144(8);
  cursor: pointer;
  .select-icon {
    position: absolute;
    left: 50%;
    color: #d6dde2;
  }
  .icon-up {
    top: px2rem144(-18);
    transform: translate(-50%);
  }
  .icon-down {
    top: px2rem144(-19);
    transform: translate(-50%);
  }
}
.schedule-chart-open {
  height: px2rem144(238);
}
.schedule-chart-collapse {
  height: 0;
}
.schedule-popover-content {
  width: px2rem144(140);
}
.right-inner-drawer {
  width: 240px;
  position: relative;
}
@media screen and (max-width: 1200px) {
  .right-inner-drawer {
    position: absolute;
    z-index: 10;
    right: 0;
    top: 0;
    bottom: 0;
  }
}
</style>
